/**
 * 过滤特殊字符
 *
 * @param text - 要过滤的文本
 * @returns 过滤后的文本
 */
export const filterSpecialChars = (text: string) => {
    return text.replace(/[\x00-\x09\x0b-\x1f\x7f-\x9f]/gi, '');
};

/**
 * 按用户可见 grapheme 切分文本。
 *
 * @param text - 要切分的文本。
 * @returns 保持 emoji、代理对和组合字符完整的 grapheme 列表。
 */
export const segmentGraphemes = (text: string): string[] => {
    if (typeof Intl.Segmenter === 'undefined') return Array.from(text);

    return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text), (item) => item.segment);
};
